export const QA_NAME_SETTINGS_SECTION = 'settings'
